import { baseUrlProxy } from './env'
import axios from 'axios'
import { Message, MessageBox } from 'element-ui'

// create an axios instance
const service = axios.create({
  baseURL: baseUrlProxy, // api的base_url
  // timeout: 2000, // request timeout
  withCredentials: true // 跨域同步请求
})
// request interceptor
service.interceptors.request.use(config => {
  // config.headers['Cookie'] ='language=zh; USER_TOKEN:6e95aac9b2be40eaa1eec44aafd6f935'
  return config
}, error => {
  // Do something with request error
  console.log(error) // for debug
  Promise.reject(error)
})

// respone interceptor
service.interceptors.response.use(
  response => response.data,
  error => {
    if (error.response.status === 401) {
      MessageBox.alert(error.response.data.message, '提示', {
        confirmButtonText: '重新登录',
        type: 'warning',
        callback: action => {
          window.location.href = window.location.protocol + '//' + window.location.host
        }
      })
    } else {
      Message({
        // message: error,
        message: error.response.data.message,
        type: 'error',
        duration: 5 * 1000,
        customClass: 'messageIndex'
        // duration: 5 * 10000000
      })
    }
    return Promise.reject(error)
  })

export default service
